import { SET_SYSTEM_COMMENTS } from 'actions';

export function setSystemComments(systemComments: string) {
  return { systemComments, type: SET_SYSTEM_COMMENTS };
}
